<div [innerHTML]="svgContent()" [style.width]="width() + 'px'" [style.height]="height() + 'px'"></div>
